import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DistaDialog, DistaDialogHeader } from "@sista/dista-ui";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, DialogContent, Typography } from "@mui/material";
import { Right } from "@sista/library-stasi";
import { SelectVariantUrns } from "../parts/SelectVariantUrns";
const emptyUrnsData = {
    providerUrns: [],
    programUrns: [],
    cfpUrns: [],
};
export const AddTextVariantDialog = ({ canEdit, tree, onAddVariant, onClose, }) => {
    const { t } = useTranslation("sprava-textu");
    const [urnsData, setUrnsData] = useState(emptyUrnsData);
    const onSuccessHandler = useCallback(() => {
        if (onAddVariant) {
            onAddVariant(urnsData);
            return setUrnsData(emptyUrnsData);
        }
    }, [onAddVariant, urnsData]);
    return (_jsxs(DistaDialog, { open: true, onClose: onClose, children: [_jsx(DistaDialogHeader, { title: t("sprava-textu.admin.addVariant.title", "Přidat variantu textu"), onClose: onClose }), _jsxs(DialogContent, { children: [_jsx(Typography, { variant: "body1", sx: { mb: 2 }, children: t("sprava-textu.admin.addVariant.description", "Nastavte URN:") }), _jsx(SelectVariantUrns, { canEdit: canEdit, data: urnsData, tree: tree, stacked: true, onChange: (data) => {
                            return setUrnsData(data);
                        } }), _jsx(Right, { children: _jsx(Button, { variant: "contained", onClick: () => {
                                return onSuccessHandler();
                            }, disabled: urnsData.providerUrns.length === 0, children: t("sprava-textu.admin.addVariant.button", "Přidat variantu") }) })] })] }));
};
